export default "__VITE_ASSET__DJs2D4kr__"